import type { FC } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './lib/AuthProvider';
import { ProtectedRoute } from './lib/ProtectedRoute';
import SupervisorLogin from './components/SupervisorLogin/SupervisorLogin';
import SupervisorRegistration from './components/SupervisorRegistration/SupervisorRegistration';
import StudentLogin from './components/StudentLogin/StudentLogin';
import StudentRegistration from './components/StudentRegistration/StudentRegistration';
import RegistrationSuccess from './components/Registration/RegistrationSuccess';
import VerifyEmail from './components/Registration/VerifyEmail';
import StudentHome from './components/StudentHome/StudentHome';
import OJTCoordinatorHome from './components/OJTCoordinator/OJTCoordinatorHome';
import SupervisorHome from './components/SupervisorHome/SupervisorHome';

const App: FC = () => {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<StudentLogin />} />
            <Route path="/supervisor" element={<SupervisorLogin />} />
            <Route path="/register" element={<StudentRegistration />} />
            <Route path="/supervisor-registration" element={<SupervisorRegistration />} />
            <Route path="/registration-success" element={<RegistrationSuccess />} />
            <Route path="/verify" element={<VerifyEmail />} />
            <Route
              path="/ojt-coordinator/home" 
              element={
                <ProtectedRoute requiredRole="ojt_coordinator">
                  <OJTCoordinatorHome />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/supervisor/home" 
              element={
                <ProtectedRoute requiredRole="supervisor">
                  <SupervisorHome />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/student/home" 
              element={
                <ProtectedRoute requiredRole="student">
                  <StudentHome />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
